import { useState } from 'react'
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination
} from '@mui/material'
import SortingIcon from '../SortingIcon'
import TestRunsListItem from './TestRunsListItem'
import { sortTableItems } from '../../utils/sortTableItems'

const TestRunsTable = ({ testCase, testRuns, selectedVersion, onRunSelect = null }) => {
  const [sortConfig, setSortConfig] = useState({ key: 'updated_at', direction: 'desc' })
  const [page, setPage] = useState(1)

  const testRunsPerPage = 10

  const sortedTestRuns = sortTableItems(testRuns, sortConfig)

  const filteredTestRuns = selectedVersion && selectedVersion !== "All Versions"
    ? sortedTestRuns.filter(run => run.version.testCaseId === selectedVersion)
    : sortedTestRuns

  const paginatedTestRuns = filteredTestRuns.slice((page - 1) * testRunsPerPage, page * testRunsPerPage)

  const startItem = (page - 1) * testRunsPerPage + 1
  const endItem = Math.min(page * testRunsPerPage, filteredTestRuns.length)

  const handlePageChange = (event, value) => {
    setPage(value)
  }

  const handleSortChange = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === 'asc' ? 'desc' : 'asc',
    }))
  }

  const renderSortableHeader = (key, label) => (
    <Box
      className="runsAccordionTableHeaderCellContent"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
    >
      <SortingIcon sortConfig={sortConfig} currentKey={key}/>
      <span>{label}</span>
    </Box>
  )

  return (
    <>
      <TableContainer className='runsAccordionTableContainer' component={Paper}>
        <Table className='runsAccordionTable' stickyHeader>
          <TableHead className='runsAccordionTableHeader'>
            <TableRow>
              <TableCell className='runsAccordionTableHeaderCell nonInteractiveHeaderCell'>
                Test Case Name
              </TableCell>
              <TableCell className='runsAccordionTableHeaderCell' onClick={() => handleSortChange('started_at')}>
                {renderSortableHeader('started_at', 'Version')}
              </TableCell>
              <TableCell className='runsAccordionTableHeaderCell' onClick={() => handleSortChange('status')}>
                {renderSortableHeader('status', 'Status')}
              </TableCell>
              <TableCell className='runsAccordionTableHeaderCell' onClick={() => handleSortChange('created_by')}>
                {renderSortableHeader('created_by', 'Created by')}
              </TableCell>
              <TableCell className='runsAccordionTableHeaderCell' onClick={() => handleSortChange('updated_at')}>
                {renderSortableHeader('updated_at', 'Date and Time')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            { paginatedTestRuns.length ?
              paginatedTestRuns.map((testRun) => (
                <TestRunsListItem
                  key={testRun.id}
                  testRun={testRun}
                  testCase={testCase}
                  onSelectRun={onRunSelect}
                />
              )) :
              <TableRow>
                <TableCell colSpan={5}>
                  <Typography variant="body1" align="center">
                    No data available.
                  </Typography>
                </TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
      { testRuns.length ?
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mt: 2 }}>
          <Typography variant="body2" mr={1}>
            {`${startItem}-${endItem} of ${filteredTestRuns.length}`}
          </Typography>
          <Pagination
            count={Math.ceil(filteredTestRuns.length / testRunsPerPage)}
            page={page}
            onChange={handlePageChange}
            shape="rounded"
            color='primary'
          />
        </Box> : null }
    </>
  )
}

export default TestRunsTable
